<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="categorySelected"
            :options="categories"
            :defaultSelected="defaultSelected ? {id: defaultSelected.enumName} : categories[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import {mapGetters} from 'vuex';

    export default {
        name: "CarCategoryDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            this.setCategories();
        },
        data() {
            return {
                categories: []
            }
        },
        methods: {
            categorySelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
                    currentValueId: value.currentValue.id,
                    oldValue: value.oldValue
                });
            },
            setCategories() {
                this.categories = [];
                this.categories.push({
                    id: 'none',
                    name: '(всички)'
                });
                if (this.carCategories && Array.isArray(this.carCategories)) {
                    this.carCategories.forEach(category => {
                        category.id = category.enumName;
                        this.categories.push(category)
                    });
                }
            }
        },
        computed: {
            ...mapGetters(['carCategories'])
        },
        watch: {
            carCategories: {
                handler() {
                    this.setCategories();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
